/* Accessible accordion used by FAQ sections and product collapsible tabs. */
if (!customElements.get('q-accordion')) {
  customElements.define(
    'q-accordion',
    class QAccordion extends HTMLElement {
      connectedCallback() {
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelectorAll('[aria-controls]').forEach((button) => {
          if (button.dataset.qBound) return;
          button.dataset.qBound = 'true';
          button.addEventListener('click', () => this.toggle(button));
          if (button.getAttribute('aria-expanded') === 'true') {
            const panel = this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
            if (panel) {
              panel.hidden = false;
              panel.style.maxHeight = 'none';
            }
          }
        });
      }

      toggle(button) {
        const panel = this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
        if (!panel) return;
        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        button.classList.toggle('active', !open);
        if (open) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          requestAnimationFrame(() => {
            panel.style.maxHeight = '0px';
          });
          const done = () => {
            panel.hidden = true;
            panel.removeEventListener('transitionend', done);
          };
          if (this.reduceMotion) done();
          else panel.addEventListener('transitionend', done);
        } else {
          panel.hidden = false;
          panel.style.maxHeight = '0px';
          requestAnimationFrame(() => {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          });
          const done = () => {
            panel.style.maxHeight = 'none';
            panel.removeEventListener('transitionend', done);
          };
          if (this.reduceMotion) done();
          else panel.addEventListener('transitionend', done);
        }
      }
    }
  );
}
